/* @flow */
import type {SearchRequestQueryResponseData} from '../queries/searchRequestQuery';

export const SEARCH_REQUEST_QUERY_COMPLETE = 'SEARCH_QUERY/COMPLETE';
export const SEARCH_REQUEST_QUERY_START = 'SEARCH_QUERY/START';

type SearchRequestQueryStartActionType = 'SEARCH_QUERY/START';
type SearchRequestQueryCompleteActionType = 'SEARCH_QUERY/COMPLETE';

type SearchRequestQueryStartPayloadType = {
    data: SearchRequestQueryResponseData,
    prevData: SearchRequestQueryResponseData
};

export type SearchRequestQueryCompleteAction = {
    type: SearchRequestQueryCompleteActionType,
    payload: SearchRequestQueryResponseData
};

export type SearchRequestQueryStartAction = {
    type: SearchRequestQueryStartActionType,
    payload: SearchRequestQueryStartPayloadType
};

export type Action =
    | SearchRequestQueryCompleteAction
    | SearchRequestQueryStartAction;

const ACTION_CREATORS = {
    searchRequestQueryComplete(
        data: SearchRequestQueryResponseData
    ): SearchRequestQueryCompleteAction {
        return {
            type: SEARCH_REQUEST_QUERY_COMPLETE,
            payload: data
        };
    },
    searchRequestQueryStart(
        payload: SearchRequestQueryStartPayloadType
    ): SearchRequestQueryStartAction {
        return {
            type: SEARCH_REQUEST_QUERY_START,
            payload
        };
    }
};

export default {...ACTION_CREATORS};
